import { useEffect, useState } from 'react';
import { api } from '../api';
import { ErrorNote } from './ui';

/** Shows a PDF from the API inline (fetched with the user's sign-in, so it can't be a plain link). */
export function PdfFrame({ path, title, height = 640 }: { path: string; title: string; height?: number }) {
  const [url, setUrl] = useState<string | null>(null);
  const [error, setError] = useState<unknown>(null);
  useEffect(() => {
    let u: string | null = null; let live = true;
    api.blob(path).then((b) => { if (!live) return; u = URL.createObjectURL(b.type === 'application/pdf' ? b : new Blob([b], { type: 'application/pdf' })); setUrl(u); }).catch((e) => live && setError(e));
    return () => { live = false; if (u) URL.revokeObjectURL(u); };
  }, [path]);
  if (error) return <ErrorNote error={error} />;
  if (!url) return <p className="empty">Loading the document…</p>;
  return <iframe className="pdf-frame" title={title} src={url} style={{ height }} />;
}
